module.exports = __webpack_public_path__ + "img/Best of Spanien Rot.12ecbbdd.jpg";